import React, { useMemo } from 'react';
import { User } from 'lucide-react';
import { GetAssureDetailsResponse, NaturalPersonDto, LegalEntityDto } from 'api/actor';
import { EntityDetailsHeader, EntityDetailsHeaderConfig } from 'components/display/EntityDetailsHeader';

export interface PersonDetailsHeaderProps {
  personDetails: GetAssureDetailsResponse;
}

const PersonDetailsHeader: React.FC<PersonDetailsHeaderProps> = ({ personDetails }) => {
  const config: EntityDetailsHeaderConfig = useMemo(() => {
    const details = personDetails.details;

    // Get person name based on type (physical or legal)
    const getPersonName = () => {
      if (details?.type === 'physique') {
        const person = details as NaturalPersonDto;
        return `${person.firstName || ''} ${person.lastName || ''}`.trim() || 'Nom inconnu';
      }
      if (details?.type === 'morale') {
        const entity = details as LegalEntityDto;
        return entity.companyName || 'Raison sociale inconnue';
      }
      return 'Personne inconnue';
    };

    return {
      icon: <User className="w-8 h-8 text-primary" />,
      title: getPersonName(),
      subtitle: personDetails.header?.personType || 'Prospect',
      infoSections: []
    };
  }, [personDetails]);

  return <EntityDetailsHeader config={config} />;
};

export default PersonDetailsHeader;
